// Figma: "Background+VerticalBorder" (node 18034:1277) on the Community Dashboard page.
// STRUCTURAL NOTE: LC2 had no persistent left sidebar — this same set of destinations
// (Today/Performance/Engagement/CRM/StakeSay/ESG) existed as horizontal tabs inside the
// dashboard body (src/commons/components/HomeTabs/HomeTabs.js), driven by the SAME
// `menu` reducer's `openTab`/`activeTab` used here. "Communities", "Invoices" (split out
// of LC2's combined "CRM / Invoices" tab), and "Reports" are new destinations with no
// existing tab component yet — wired the same way, content to be ported in a follow-up pass.
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Box, ButtonBase, Stack, Typography} from '@mui/material';

import {activeTab, getOpenTab} from '../../app/store/reducers/menu';
import {tokens} from '../../themes/ThemeCustomization';
import AccountSwitcher from './AccountSwitcher';

import navTodayIcon from '../../assets/shell/nav-today-icon.svg';
// import navPerformanceIcon from '../../assets/shell/nav-performance-icon.svg';
// import navEngagementIcon from '../../assets/shell/nav-engagement-icon.svg';
import navCrmIcon from '../../assets/shell/nav-crm-icon.svg';
// import navStakeSayIcon from '../../assets/shell/nav-stakesay-icon.svg';
import navEsgIcon from '../../assets/shell/nav-esg-icon.svg';
import navInvoicesIcon from '../../assets/shell/nav-invoices-icon.svg';
import navReportsIcon from '../../assets/shell/nav-reports-icon.svg';

// Same tab ids as LC2's HomeTabs.js homeTabsInfo, plus the three new destinations.
const NAV_ITEMS = [
    {id: 'today', label: 'Today', icon: navTodayIcon},
    // Communities is hidden for now — restore this entry to bring it back.
    // {id: 'communities', label: 'Communities', icon: navCommunitiesIcon},
    // Performance is hidden for now — restore this entry (and its icon import) to bring it back.
    // {id: 'performance', label: 'Performance', icon: navPerformanceIcon},
    // Engagement is hidden for now — restore this entry (and its icon import) to bring it back.
    // {id: 'engagement', label: 'Engagement', icon: navEngagementIcon},
    {id: 'crm', label: 'CRM', icon: navCrmIcon},
    // StakeSay is hidden for now — restore this entry (and its icon import) to bring it back.
    // {id: 'stakesay', label: 'StakeSay', icon: navStakeSayIcon},
    {id: 'esg', label: 'ESG', icon: navEsgIcon},
    {id: 'invoices', label: 'Invoices', icon: navInvoicesIcon},
    {id: 'reports', label: 'Reports', icon: navReportsIcon}
];

const Sidebar = ({communityName = 'Loyalty Cloud'}) => {
    const dispatch = useDispatch();
    const openTab = useSelector(getOpenTab) || 'today';

    return (
        <Box
            component="nav"
            sx={{
                width: '255px',
                minWidth: '240px',
                height: '100vh',
                position: 'sticky',
                top: 0,
                flexShrink: 0,
                backgroundColor: tokens.color.neutral50,
                borderRight: `1px solid ${tokens.color.neutral200}`,
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Stack
                direction="row"
                alignItems="center"
                sx={{borderBottom: `1px solid ${tokens.color.neutral200}`, p: 1, gap: 1}}
            >
                <AccountSwitcher currentAccountName={communityName} />
            </Stack>

            <Stack sx={{p: 1, gap: '1px'}}>
                {NAV_ITEMS.map((item) => {
                    const isActive = openTab === item.id;
                    return (
                        <ButtonBase
                            key={item.id}
                            onClick={() => dispatch(activeTab(item.id))}
                            sx={{
                                height: 36,
                                borderRadius: '6px',
                                justifyContent: 'flex-start',
                                gap: 1,
                                pl: 1.25,
                                pr: 1,
                                backgroundColor: isActive ? tokens.color.neutral200 : 'transparent',
                                '&:hover': {backgroundColor: isActive ? tokens.color.neutral200 : tokens.color.neutral100}
                            }}
                        >
                            <Box component="img" src={item.icon} alt="" sx={{width: 16, height: 16}} />
                            <Typography
                                variant="body2"
                                fontWeight={500}
                                sx={{color: isActive ? tokens.color.neutral950 : tokens.color.neutral500}}
                            >
                                {item.label}
                            </Typography>
                        </ButtonBase>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default Sidebar;
